<template>
  <div v-loading="loading" class="resetpwdBody">
    <div class="_title">
      <p class="_title_info">重置账号密码</p>
    </div>
    <el-form
      ref="changeForm"
      :rules="rules"
      :model="changeForm"
      label-position="right"
      class="_jbxxForm"
      label-width="95px"
    >
      <el-form-item label="单位名称：" prop="dwmc">
        <el-input v-model="changeForm.dwmc" />
      </el-form-item>
      <el-form-item label="账号：" prop="loginName">
        <el-input v-model="changeForm.loginName" />
      </el-form-item>
      <div style="width: 100%;text-align: left;color:red;margin-left: 95px;">
        <p>提示：1.密码将重置为'yzd@'+手机号后四位（如'yzd@4321'）</span></p>
        <p style="margin-left: 48px;">2.提交过入网申请（无论是否已入网或停用）的企业都可以在此处重置密码</p>
      </div>
      <div class="buttonList">
        <el-button @click="reset"> 清 空</el-button>
        <el-button type="primary" @click="submit"> 确 认</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { resetpwd } from '@/assets/js/bmgl.js'
export default {
  name: 'Resetpwd',
  data() {
    return {
      loading: false,
      changeForm: {
        dwmc: '',
        loginName: ''
      },
      rules: {
        dwmc: [
          {
            required: true,
            message: '单位名称不能为空',
            trigger: 'change'
          }
        ],
        loginName: [
          {
            required: true,
            message: '账号不能为空',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    reset() {
      this.changeForm = { dwmc: '', loginName: '' }
    },
    submit() {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.$confirm(
            '此操作将重置密码, 是否继续?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.loading = true
              resetpwd({ 'dwmc': this.changeForm.dwmc }, this.changeForm.loginName)
                .then((e) => {
                  this.$message.success('重置成功')
                  this.loading = false
                })
                .catch(() => {
                  this.loading = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.resetpwdBody {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0px auto;
  }
}
</style>
